/** @format */

export const ViewUserDetail = (): JSX.Element => {
  return <></>;
};
